
import BreedsData from "../../data/breeds";
import LocationData from "../../data/locations";

export type ParameterBreed = keyof typeof BreedsData.parameters;
export type EnterpriseKeys = 'cattle' | 'sheep';

export const Breeds: typeof BreedsData & {
	// cattle: {
	// 	names: string[];
	// 	classes: {
	// 		breeding: string[],
	// 		trading: string[]
	// 	}
	// };
	// [key in Enterprises]: typeof BreedsData.cattle,
	parameters: {
		[key in ParameterBreed]: {
			[key in BreedNamesShort]: number | null
		}
	};
} = BreedsData;

export type BreedNamesCattle = typeof BreedsData.cattle.names[number];
export type BreedNamesSheep = typeof BreedsData.sheep.names[number];
export type BreedNames = BreedNamesCattle | BreedNamesSheep;

export type BreedNamesShort = keyof typeof BreedsData.parameters['Twins:a'];

export type StockNamesCattle = typeof BreedsData.cattle.classes.breeding[number];
export type StockNamesSheep = typeof BreedsData.sheep.classes.breeding[number];
export type StockNames = StockNamesCattle | StockNamesSheep;

const AllBreedNames = [...BreedsData.cattle.names, ...BreedsData.sheep.names];

export function breedTypeToName(type: number) {
	return AllBreedNames[type - 1];
}

export const Locations = LocationData;
